var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumTimeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stopwatch_2w",
    clipPath: "url(#clip0_1064_1184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.888 18.1289C29.888 25.7865 23.68 31.9956 16.0213 31.9956C8.36266 31.9956 2.15466 25.7865 2.15466 18.1289C2.15466 10.8308 7.79626 4.86281 14.9547 4.31561V2.12894H13.888V-0.00439453H18.1547V2.12894H17.088V4.31561C20.2219 4.55561 23.0645 5.83347 25.2704 7.80681L26.688 6.38921L28.8213 8.52894L27.2832 10.0671C28.9141 12.3401 29.888 15.1156 29.888 18.1289ZM16.0213 6.39667C9.54133 6.39667 4.288 11.65 4.288 18.13C4.288 24.61 9.54133 29.8623 16.0213 29.8623C22.5013 29.8623 27.7547 24.61 27.7547 18.13C27.7547 11.6489 22.5013 6.39667 16.0213 6.39667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5255 19.5253C13.6928 18.6927 13.6928 17.341 14.5255 16.5084C15.3582 15.6757 16.7098 15.6757 17.5425 16.5084C18.3752 17.341 18.3752 18.6927 17.5425 19.5253L17.5425 27.0678L16.034 27.0678L14.8166 19.7637C14.7148 19.6905 14.616 19.6159 14.5255 19.5253Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_1184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumTimeActive);
export default __webpack_public_path__ + "static/media/mediumTimeActive.83be5fb8d881bfb42b4dd37a68e08d23.svg";
export { ForwardRef as ReactComponent };